import React from "react"
import { Edit, FormDataConsumer, ImageField, ImageInput, required, SelectInput, SimpleForm, TextInput } from "react-admin"

const CarouselEdit = props => {
    return (
        <Edit {...props}>
            <SimpleForm>
                <TextInput source="link_url" label="Link url" validate={[required()]} />
                <SelectInput
                    source="type"
                    choices={[
                        { id: "DYNAMIC_IMAGES", name: "Dynamic images" },
                        { id: "DASHBOARD", name: "Dashboard" },
                        { id: "MINI_DASHBOARD", name: "Mini Dashboard" },
                        { id: "DASHBOARD_TRIAL", name: "Dashboard trial" },
                        { id: "PUBLIC_TEMPLATES", name: "Public templates" },
                        { id: "AUTOMATE", name: "Automate" },
                    ]}
                    alwaysOn
                />
                <ImageField source="image_url" label="Previous image" />
                <ImageInput source="image_url_data" label="Image Url" accept="image/*" multiple={false}>
                    <ImageField source="image_url_data" />
                </ImageInput>
                <FormDataConsumer>
                    {({ formData, ...rest }) =>
                        formData.type === "MINI_DASHBOARD" && (
                            <>
                                <SelectInput
                                    source="color"
                                    choices={[
                                        { id: "PURPLE", name: "purple" },
                                        { id: "ORANGE", name: "orange" },
                                        { id: "BLUE", name: "blue" },
                                        { id: "GREEN", name: "green" },
                                    ]}
                                    alwaysOn
                                />
                                <TextInput source="category" label="Category" />
                                <TextInput source="title" label="Title" validate={[required()]} />
                                <TextInput source="description" label="Description" validate={[required()]} />
                            </>
                        )
                    }
                </FormDataConsumer>
            </SimpleForm>
        </Edit>
    )
}

export default CarouselEdit
